import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { FormatMoney } from '../../utilities/formats';

export const ListPrices = (props) => {    
    const { prices = [], onClick,clean, limpiar } = props;
        
    const [clicked, setClickedBtn] = useState(false);
    const [indexBtn, setIndexBtn] = useState(-1);    

    const handleClick = (index) => {
        clean(true);
        setClickedBtn(true);
        setIndexBtn(index);
    }

    useEffect(() => {
        setClickedBtn(limpiar)
    }, [limpiar]);

    return (
        <div>
            {prices.map((price, i) => {
                let btn_class;
                if (indexBtn !== -1) {
                    if (indexBtn === i) {
                        btn_class = clicked ? "#bedb02" : ""
                    }
                }
                return (
                    <Button index={i} className='m-1' variant='info' 
                    style={{ width: 100, backgroundColor: btn_class }} 
                    key={i} onClick={() => { onClick(price, i); handleClick(i) }}>  
                    {FormatMoney(price)}  </Button>
                )
            })}
        </div>
    )

}

export const ListNumberTicket = (props) => {
    const { numbers = [], selectTicket, active } = props;
    const [clicked, setClickedBtn] = useState(false);
    const [indexBtn, setIndexBtn] = useState(-1);
    const handleClick = (index) => {
      setClickedBtn(true);
      setIndexBtn(index);
    };
    console.log("ListNumberTicket number", numbers);
  
    // Filtrar los elementos undefined del array
    const validNumbers = numbers.filter((number) => number !== undefined);
  
    return (
      <div>
        {validNumbers.map((number, i) => {
          let btn_class = "";
          if (indexBtn !== -1 && indexBtn === i && clicked) {
            btn_class = "#bedb02";
          }
  
          return (
            <Button
              index={i}
              className='m-1'
              variant='info'
              style={{ width: 100, backgroundColor: btn_class }}
              key={i}
              onClick={() => {
                selectTicket(number.numero_boleta);
                active(false);
                handleClick(i);
              }}
            >
              {number.numero_boleta}
            </Button>
          );
        })}
      </div>
    );
  };

  export const ListNumberTicketLandinPage = (props) => {
    const { numbers = [], selectTicket, active, selectedTicket, selectedTickets = [] } = props
    const [clickedButtons, setClickedButtons] = useState(new Set())
  
    const handleClick = (index, numeroboleta) => {
      // Agregar o quitar el índice del conjunto de botones clickeados
      setClickedButtons((prev) => {
        const newSet = new Set(prev)
        if (newSet.has(index)) {
          newSet.delete(index)
        } else {
          newSet.add(index)
        }
        return newSet
      })
  
      // Llamar a la función selectTicket
      selectTicket(numeroboleta)
      active(false)
    }
  
    // Limpiar botones clickeados cuando no hay números disponibles
    useEffect(() => {
      if (numbers.length === 0) {
        setClickedButtons(new Set())
      }
    }, [numbers])
  
    // Función para verificar si un número ya está seleccionado
    const isNumberSelected = (numero) => {
      return selectedTickets.some((ticket) => ticket.numero === numero)
    }
  
    // Función para obtener el color del botón
    const getButtonColor = (numero, index) => {
      if (isNumberSelected(numero)) {
        return "#bedb02" // Verde para números ya seleccionados
      }
      if (clickedButtons.has(index)) {
        return "#bedb02" // Amarillo para el último clickeado
      }
      return "#17a2b8" // Azul por defecto
    }
  
    // Siempre renderizar los números disponibles, no el ticket seleccionado individual
    const renderAvailableTickets = () => (
      <div>
        {numbers
          .filter((number) => number !== undefined)
          .map((number, i) => (
            <React.Fragment key={i}>
              <Button
                index={i}
                className="m-1"
                variant="info"
                style={{
                  width: 100,
                  backgroundColor: getButtonColor(number.numero_boleta, i),
                  opacity: 'unset',
                }}
                onClick={() => {
                  handleClick(i, number.numero_boleta)
                }}
                disabled={isNumberSelected(number.numero_boleta)}
              >
                {number.numero_boleta}
                {isNumberSelected(number.numero_boleta) && <span style={{ marginLeft: "5px", fontSize: "12px" }}>✓</span>}
              </Button>
              {/* Add a line break after every third button */}
              {(i + 1) % 3 === 0 && i !== numbers.length - 1 && <br />}
            </React.Fragment>
          ))}
      </div>
    )
  
    // Siempre mostrar los números disponibles
    return renderAvailableTickets()
  }
 
  
  
  
  
  
  
